import { ITypedReduxAction } from 'shared/map-search/types/redux/actionType';

export enum ESeoUrlActionType {
  ClearSeoUrl = 'seoUrl/clear',
}

export type TClearSeoUrlAction = ITypedReduxAction<ESeoUrlActionType.ClearSeoUrl>;

export type TSeoUrlActions = TClearSeoUrlAction;
